import React from "react";
import HeroSection from "../sections/home/HeroSection";
import AboutIntroSection from "../sections/home/AboutIntroSection";
import StatsMarqueeSection from "../sections/home/StatsMarqueeSection";
import WhyEgyptSection from "../sections/home/WhyEgyptSection";
import CurriculumPathsSection from "../sections/home/CurriculumPathsSection";
import ServicesPreviewSection from "../sections/home/ServicesPreviewSection";
import SupportIntroSection from "../sections/home/SupportIntroSection";
import HomeCtaBannerSection from "../sections/home/HomeCtaBannerSection";

const Home: React.FC = () => {
  return (
    <div>
      <HeroSection />
      <StatsMarqueeSection />
      <AboutIntroSection />
      <WhyEgyptSection />
      <ServicesPreviewSection />
      <CurriculumPathsSection />
      <SupportIntroSection />
      <HomeCtaBannerSection />
      
    </div>
  );
};

export default Home;
